/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthProviderDto } from './AuthProviderDto';
import {
    AuthProviderDtoFromJSON,
    AuthProviderDtoFromJSONTyped,
    AuthProviderDtoToJSON,
} from './AuthProviderDto';

/**
 * 
 * @export
 * @interface AuthSettingsDto
 */
export interface AuthSettingsDto {
    /**
     * Indicates which auth providers are enabled.
     * @type {Array<AuthProviderDto>}
     * @memberof AuthSettingsDto
     */
    providers: Array<AuthProviderDto>;
    /**
     * Indicates if password authentication is enabled.
     * @type {boolean}
     * @memberof AuthSettingsDto
     */
    enablePasswordAuth: boolean;
}

/**
 * Check if a given object implements the AuthSettingsDto interface.
 */
export function instanceOfAuthSettingsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "providers" in value;
    isInstance = isInstance && "enablePasswordAuth" in value;

    return isInstance;
}

export function AuthSettingsDtoFromJSON(json: any): AuthSettingsDto {
    return AuthSettingsDtoFromJSONTyped(json, false);
}

export function AuthSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSettingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providers': ((json['providers'] as Array<any>).map(AuthProviderDtoFromJSON)),
        'enablePasswordAuth': json['enablePasswordAuth'],
    };
}

export function AuthSettingsDtoToJSON(value?: AuthSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providers': ((value.providers as Array<any>).map(AuthProviderDtoToJSON)),
        'enablePasswordAuth': value.enablePasswordAuth,
    };
}

